<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <div slot="header">Información de la Novedad</div>
          <!-- <div slot="header" v-if="!modal">Información de la Novedad</div> -->

          <!-- <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>              -->

          <b-form>
            <app-personal
              v-if="!personalReadOnly"
              label="Personal"
              :label-cols="labelCols"
              :nombre="personalNombre"
              :valido="personalValido"
              :lista="personalList"
              :msjInvalido="personalInvalidoMsj"
              @validate="validate"
              @updated="personalActualizado">
            </app-personal>  

            <b-form-group
              v-if="personalReadOnly"
              label="Personal"
              label-for="personal"
              :label-cols="labelCols">
              <b-form-input 
                id="personal"
                :value="personalNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <app-tipo-novedad
              label="Tipo de Novedad"
              :label-cols="labelCols"
              :nombre="tipoNovedadNombre"
              :valido="tipoNovedadValida"
              :lista="tiposNovedadesList"
              :msjInvalido="tipoNovedadInvalidaMsj"
              @validate="validate"
              @updated="tipoNovedadActualizada"
              v-if="!Boolean(vacaciones)">
            </app-tipo-novedad>  

              <!-- :label='Boolean(faltaHora) ? "Fecha" : "Fecha Desde"' -->
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols">
              <b-form-input 
                id="fechaDesde"
                v-model.trim="$v.fechaDesde.$model"
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- v-if="!Boolean(faltaHora)" -->
            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols">
              <b-form-input 
                id="fechaHasta"
                v-model.trim="$v.fechaHasta.$model"
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <app-time-desde
              label="Desde"
              :label-cols="labelCols"
              :nombre="timeDesde"
              :valido="timeDesdeValido"
              :lista="horario"
              :msjInvalido="timeDesdeInvalidoMsj"
              @validate="validate"
              @updated="timeDesdeActualizado"
              v-if= 'Boolean(faltaHora)'>
            </app-time-desde>  

            <app-time-hasta
              label="Hasta"
              :label-cols="labelCols"
              :nombre="timeHasta"
              :valido="timeHastaValido"
              :lista="horario"
              :msjInvalido="timeHastaInvalidoMsj"
              @validate="validate"
              @updated="timeHastaActualizado"
              v-if="Boolean(faltaHora)">
            </app-time-hasta>   -->

            <b-form-group
              label="Periodo"
              label-for="periodo"
              :label-cols="labelCols"
              v-if="Boolean(vacaciones)">
              <b-form-input 
                id="periodo"
                v-model.trim="$v.periodoAnio.$model"
                :state="periodoValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="periodoFeedback">
                {{ periodoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols">
              <b-form-textarea
                id="observaciones"
                v-model.trim="$v.observaciones.$model"
                :state="observacionesValido"
                type="text"
                @blur.native="validate"
                rows="3"
                max-rows="6">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if="!modal"
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Personal from '../shared/abmSelect.vue';
import TipoNovedad from '../shared/abmSelect.vue';
// import TimeDesde from '../shared/abmSelect.vue';
// import TimeHasta from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, requiredIf, maxLength, numeric, decimal } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personalNovedad/getField',
  mutationType: 'personalNovedad/updateField',
});

export default {
  name: 'PersonalNovedadesABM',
  components: {
    appABMButton: ABMButtons,
    appPersonal: Personal,
    appTipoNovedad: TipoNovedad,
    appMensaje: Mensaje
    // appTimeDesde: TimeDesde,
    // appTimeHasta: TimeHasta
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    personalNovedadId: {
      type: Number,
      default: 0,
    },
    vacaciones: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    personalParam: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',
      personalValido: null,
      personalInvalidoMsj: '',
      tipoNovedadValida: null,
      tipoNovedadInvalidaMsj: '',
      observacionesValido: null,
      observacionesInvalidoMsj: '',
      // timeDesdeValido: null,
      // timeDesdeInvalidoMsj: '',
      // timeHastaValido: null,
      // timeHastaInvalidoMsj: '',
      periodoValido: null,
      periodoInvalidoMsj: '',

      personel: [],
      personalList: [],
      tiposNovedades: [],
      tiposNovedadesList: [],

      labelCols: 2,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      personalReadOnly: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaDesde',
      'fechaHasta',
      // 'timeDesde',
      // 'timeHasta',
      // 'horario',
      'periodoAnio',
      'personal',
      'personalNombre',
      'tipoNovedad',
      'tipoNovedadNombre',
      'observaciones',
    ])
  },
  created() {
    //this.getDatosAdicionales()

    let personalNovedadId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        personalNovedadId = this.$route.params.id;
      }
    }

    let params = {};

    if (personalNovedadId != 0) {
      params = {
        personalNovedadId: personalNovedadId,
        vacaciones: this.vacaciones
      }
    } else {
      params = {
        personalNovedadId: this.personalNovedadId,
        // faltaHora: this.faltaHora,
        vacaciones: this.vacaciones,
        personal: this.personalParam
      }
    }

    if (this.personalParam) {
      this.personalReadOnly = true;
    }

    if (this.modal) {
      this.labelCols = 3;
    }

    this.showSpinner();
    this.$store.dispatch('personalNovedad/inicializar', params)
      .then(() => this.getDatosAdicionales())
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());

  },
  methods: {
    // countDownChanged(dismissCountDown) {
    //   this.dismissCountDown = dismissCountDown;
    // },
    // showAlert(error) {
    //   let mensaje = 'Error';

    //   /* Verificamos si el parametro es un objeto (Error) o un string */
    //   if (error) {
    //       if (typeof(error) === 'object') {
    //           if (error.hasOwnProperty('message')) {
    //               mensaje = error.message;
    //           }
    //       } else if (typeof(error) === 'string') {
    //           mensaje = error;
    //       }
    //   }

    //   this.alertMsj = mensaje;
    //   this.alertVariant = 'danger';
    //   this.alertCountDown = 15;
    //   this.dismissCountDown = this.alertCountDown;
    // },
    getDatosAdicionales() {
      const vm = this;

      if (!this.personalReadOnly) {
        this.$store.dispatch('personel/getList', Boolean(true))
          .then(() => {
            vm.personel = this.$store.getters['personel/list'];
            vm.personalList = this.$store.getters['personel/selectList'];
            
            /* Verificamos si el personal esta incluido en la lista (o esta dado de baja) */
            if (vm.personal) {
              if (vm.personal.id != 0) {
                let personal = vm.personel.find( p => p.id == vm.personal.id ); 
                if (!personal) {
                  let item = {
                    id: vm.personal.id,
                    nombre: vm.personal.nombre
                  }
                  vm.personel.push(item);
                  vm.personalList.push (vm.personalNombre);
                  /* Ordenamos el array de nombres */
                  vm.personalList.sort();
                  //vm.personel = vm.personel.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0)); 
                }
              }
            }
          })
          .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la información de personal.')));
      }

      if (!this.vacaciones) {
        // let params = {
        //   incluirVacaciones: Boolean(false),
        //   incluirFaltasDias: !Boolean(this.faltaHora),
        // }

        this.$store.dispatch('tiposNovedades/getTiposNovedades')
          .then(() => {
            vm.tiposNovedades = this.$store.getters['tiposNovedades/tiposNovedades'];
            // vm.tiposNovedadesList = vm.tiposNovedades.map(tipoNovedad => tipoNovedad.nombre.trim());

            let itemKey = vm.tiposNovedades.findIndex(t => t.id == 1);
            if (itemKey != -1) {
                vm.tiposNovedades.splice(itemKey, 1);
            }

            vm.tiposNovedadesList = vm.tiposNovedades.map(tipoNovedad => tipoNovedad.nombre.trim());

          })
          .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la información de tipos de novedades.')));
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      // if (campo == 'personalNombre' || validarTodos) {
      //   if (this.$v.personalNombre.$error) {
      //     this.personalValido = false
      //     if (!this.$v.personalNombre.required) {
      //       this.personalInvalidoMsj = 'Debe seleccionar el personal correspondiente.'
      //     }      
      //   } else {
      //     this.personalValido = null;
      //     this.personalInvalidoMsj = '';
      //   }
      // }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValido = false
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidoMsj = 'Las observaciones solo pueden contener hasta 250 caracteres.'
          }      
        } else {
          this.observacionesValido = null;
          this.observacionesInvalidoMsj = '';
        }
      }

    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      if (!this.personalReadOnly) {
        let personal = null;
        if (this.personalNombre) {
          personal = this.getSelected(this.personel, this.personalNombre);
        }
        let personalError = true;
        if (personal) {
          if (personal.id) {
            if (personal.id != 0) {
              this.$store.dispatch('personalNovedad/setPersonal', personal);
              personalError = false;
            }
          }
        }
        if (personalError) {
          save = false;
          this.personalValido = false;
          this.personalInvalidoMsj = 'Debe seleccionar el personal correspondiente';
        }
      }

      if (!this.vacaciones) {
        let tipoNovedad = null;
        if (this.tipoNovedadNombre) {
          tipoNovedad = this.getSelected(this.tiposNovedades, this.tipoNovedadNombre);
        }
        this.$store.dispatch('personalNovedad/setTipoNovedad', tipoNovedad);

        let tipoNovedadError = true;
        if (this.tipoNovedad) {
          if (this.tipoNovedad.id) {
            if (this.tipoNovedad.id != 0) {
              tipoNovedadError = false;
            }
          }
        }
        if (tipoNovedadError) {
          save = false;
          this.tipoNovedadValida = false;
          this.tipoNovedadInvalidaMsj = 'Debe seleccionar el tipo de novedad';
        }

      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('personalNovedad/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    close() {
      this.$emit('close', false);
    },
    goList() {
      if (this.modal) {
        this.$emit('close', true);
      } else {
        this.$router.push({ name: "PersonalNovedades" });
      }
    },
    personalActualizado(personalNombre) {
      this.personalNombre = personalNombre;
    },
    tipoNovedadActualizada(tipoNovedadNombre) {
      this.tipoNovedadNombre = tipoNovedadNombre;

      this.tipoNovedadValida = null;
      this.tipoNovedadInvalidaMsj = '';
    },
    // timeDesdeActualizado(timeDesde) {
    //   this.$store.dispatch('personalfalta/setTimeDesde', timeDesde);
    // },
    // timeHastaActualizado(timeHasta) {
    //   this.$store.dispatch('personalfalta/setTimeHasta', timeHasta);
    // },
  },
  /* Vuelidate */
  validations: {
    fechaDesde: {},
    fechaHasta: {},
    periodoAnio: {},
    observaciones: {
      maxLength: maxLength(2500)
    },
  },  
}
</script>

<style>
</style>
